import { Permission } from "../authSchema";

export type Context = {
    data: Record<string, any>;
    name: string;
};

export type Role = {
    name: string;
    permissions: Permission[];
    contexts?: Context[];
};

export enum TokenState {
    Unknown = "Unknown",
    Checking = "Checking",
    Valid = "Valid",
}
